
<template>
    <div class="cursor-move movable flex justify-between items-center">
        <div class="flex justify-start items-center">
            <div class="px-3 py-4">
                <i class="text-red-500 fas fa-file-pdf" v-if="resolveDocumentIconType() == 'pdf'"></i>
                <i class="text-blue-500 fas fa-file-word" v-if="resolveDocumentIconType() == 'document'"></i>
                <i class="text-gray-500 fas fa-image" v-else-if="resolveDocumentIconType() == 'photograph'"></i>
                <i class="text-green-500 fas fa-file-excel" v-else-if="resolveDocumentIconType() == 'table'"></i>
                <i class="text-orange-500 fas fa-file-powerpoint" v-else-if="resolveDocumentIconType() == 'presentation'"></i>
                <i class="text-yellow-500 fas fa-file-zipper" v-else-if="resolveDocumentIconType() == 'archive'"></i>
            </div>
            <div class="px-3 py-4">{{ document.metadata.name }}</div>
            <div class="px-3 py-4">{{ document.created_at }}</div>
            <div class="px-3 py-4">{{ document.created_by }}</div>
            <div class="px-3 py-4">{{ document.metadata.size }}MB</div>
            <div v-if="isSearchResult" class="px-3 py-4">{{ path }}</div>
        </div>
        <div class="px-3 py-4 flex justify-end">
            <div class="flex space-x-3">
                <a :href="document.metadata.download_url"
                    download
                    target="_blank"
                    class="font-medium text-uknar-primary hover:text-uknar-primary">
                    Download
                </a>
                <a v-on:click.stop="deleteDocument" v-if="documentsStore.canInteractWithTable"
                    class="font-medium text-rose-800 hover:text-rose-700 cursor-pointer">
                    Delete
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import { mapStores } from 'pinia';
import { useDocumentsStore } from '../../stores/documentsStore';

export default{
    name: "document-row",
    props: {
        document: {
            type: Object,
            required: true
        },
        isSearchResult: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapStores(useDocumentsStore),
        path(){
            return this.documentsStore.buildPath(this.document.metadata.virtual_path);
        }
    },
    methods: {
        async deleteDocument(){
            try{
                await this.documentsStore.destroyDocument(this.document.id);
            }
            catch(e){
                console.log(e);
            }
        },
        resolveDocumentIconType(){
            const fileType = this.document.metadata.file_type;
            if(fileType == 'pdf'){
                return 'pdf';
            }
            else if(fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png'){
                return 'photograph';
            }
            else if(fileType == 'xls' || fileType == 'xlsx'){
                return 'table';
            }
            else if(fileType == 'ppt' || fileType == 'pptx'){
                return 'presentation';
            }
            else if(fileType == 'zip' || fileType == 'rar'){
                return 'archive';
            }
            else if(fileType == 'doc' || fileType == 'docx'){
                return 'document';
            }
            else{
                return 'unknown';
            }
        }
    },
}

</script>